import { render, staticRenderFns } from "./CardRecentTrip.vue?vue&type=template&id=0201f5f8&scoped=true&"
import script from "./CardRecentTrip.vue?vue&type=script&lang=js&"
export * from "./CardRecentTrip.vue?vue&type=script&lang=js&"
import style0 from "./CardRecentTrip.vue?vue&type=style&index=0&id=0201f5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201f5f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow})
